"use client";

import { SlotContainer } from "@ospweb/sdk-ui";

import { cn } from "utils";
import { MainHeader } from "@/src/components";

interface MemberPageContentProps {
  children: React.ReactNode;
}

export function MemberPageContent({ children }: MemberPageContentProps) {
  return (
    <div className="relative flex h-full min-h-0 w-full flex-1 flex-col overflow-hidden bg-background_solid_secondary">
      <div className="w-full shrink-0 md:hidden">
        <MainHeader
          isBack={false}
          showMenuButton={false}
          className={cn(
            "flex border-b border-border_white_transparent10 bg-transparent sticky",
          )}
          slotContainerclassName="hidden"
          leftChildren={
            <SlotContainer id="member-header-left" className="flex-1" />
          }
        />
      </div>
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        {children}
      </div>
    </div>
  );
}
